<template>
  <div>
    <div class="breadcrumb">
      <v-breadcrumb>
        <!-- <v-breadcrumb-item>
          <v-icon type="home"></v-icon>
          <a @click="() => $router.push('/student/dashboard')">Dashboard </a>
        </v-breadcrumb-item> -->
        <v-breadcrumb-item>
          <span>Profile</span>
        </v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div style="padding:0 16px;box-sizing:border-box">
      <v-tabs :active-tab-key="activeTab">

        <v-tab-pane tab-key="personalDetails" tab="Personal Details">
          <v-form direction="horizontal" :model="pdForm" :rules="pdRules" ref="pdformRef">
            <div class="personal-details-wrap" style="display:flex;justify-content:space-between;">
              <div style="width:44%;">
                <v-form-item label="First Name"
                  prop="first_name">
                  <v-input size="large" v-model="pdForm.first_name" placeholder="First Name"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="Last Name"
                  prop="last_name">
                  <v-input size="large" v-model="pdForm.last_name" placeholder="Last Name"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="Date of birth"
                  prop="dob">
                  <datepicker placeholder="Date of birth" format="dd-MMM, yyyy"
                    v-model="pdForm.dob" @selected="(val) => selectDate('pdForm', 'dob', val)"></datepicker>
                </v-form-item>
                <v-form-item label="Gender"
                  prop="gender">
                  <v-select placeholder="Gender" size="large" v-model="pdForm.gender"
                    :data="[{label: 'Male', value: 'Male'}, {label: 'Female', value: 'Female'}]"
                    @change="(val) => selectChange('pdForm', 'gender', val)"></v-select>
                </v-form-item>
                <v-form-item label="Country of birth"
                  prop="country_of_birth">
                  <v-select search placeholder="Country of birth" size="large"
                    v-model="pdForm.country_of_birth" :data="countriesOptions" :filter="filterDropDown"
                    @change="(val) => selectChange('pdForm', 'country_of_birth', val)"
                    notFoundContent="No match found"></v-select>
                </v-form-item>
                <v-form-item label="Personal Email ID"
                  prop="personal_email">
                  <v-input size="large" v-model="pdForm.personal_email" placeholder="Personal Email ID"
                    autocomplete="nope"></v-input>
                </v-form-item>
              </div>
              <div style="width:44%;">
                <v-form-item label="Street Address"
                  prop="street_address">
                  <v-input size="large" v-model="pdForm.street_address" placeholder="Street Address"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="City"
                  prop="city">
                  <v-input size="large" v-model="pdForm.city" placeholder="City"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="Country"
                  prop="country">
                  <v-select search placeholder="Country" size="large"
                    v-model="pdForm.country" :data="countriesOptions" :filter="filterDropDown"
                    @change="(val) => selectChange('pdForm', 'country', val)"
                    notFoundContent="No match found"></v-select>
                </v-form-item>
                <v-form-item label="Province / State"
                  prop="province">
                  <v-input size="large" v-model="pdForm.province" placeholder="Province / State"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="Postal / Zip Code"
                  prop="zip_code">
                  <v-input size="large" v-model="pdForm.zip_code" placeholder="Postal / Zip Code"
                    autocomplete="nope"></v-input>
                </v-form-item>
                <v-form-item label="Phone Number"
                  prop="phone_number">
                  <v-input size="large" v-model="pdForm.phone_number" placeholder="Phone Number"
                    autocomplete="nope"></v-input>
                </v-form-item>
              </div>
            </div>
            <v-form-item style="margin-top: 20px;display:flex;justify-content:center;">
              <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('pdformRef')">Submit</v-button>
              <v-button type="ghost" @click.prevent="resetForm('pdformRef')">Reset</v-button>
            </v-form-item>
          </v-form>
        </v-tab-pane>

        <v-tab-pane tab-key="academicDetails" tab="Academic Details" class="academic-details">
          <v-form direction="vertical" :model="adForm" :rules="adRules" ref="adformRef">

            <v-form-item label="Highest Level of Education" prop="highest_education" :label-col="{span: 0}" :wrapper-col="{span: 14}">
              <v-select placeholder="Highest Level of Education" size="large" v-model="adForm.highest_education"
                :data="optionsStudyLevels" @change="eduLevelChange"></v-select>
            </v-form-item>

            <div style="background: #ececec;padding: 16px;height: auto;overflow:auto;">
              <v-row :gutter="16">
                <v-col :span="8" style="position:relative">
                  <v-card title="Grade 10" :bordered="false">
                    <v-form direction="vertical" :model="adForm" :rules="g10AdRules" ref="g10AdformRef">
                      <v-form-item label="Start Date" prop="g10_start_date">
                        <datepicker placeholder="Start Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g10_start_date" @change="(val) => selectChange('adForm', 'g10_start_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Completion Date" prop="g10_completion_date">
                        <datepicker placeholder="Completion Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g10_completion_date" @change="(val) => selectChange('adForm', 'g10_completion_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Institution Name" prop="g10_institution_name">
                        <v-input size="large" v-model="adForm.g10_institution_name" placeholder="Institution Name"
                          autocomplete="nope"></v-input>
                      </v-form-item>
                      <v-form-item label="Location" prop="g10_location">
                        <v-select search placeholder="Location" size="large"
                          v-model="adForm.g10_location" :data="countriesOptions" :filter="filterDropDown"
                          @change="(val) => selectChange('adForm', 'g10_location', val)"
                          notFoundContent="No match found"></v-select>
                      </v-form-item>
                    </v-form>
                  </v-card>
                  <div style="width:calc(100% - 16px);height:100%;background-color:rgba(0, 0, 0, .15);position:absolute;top:0;left:8px;padding: 16px;margin:auto;"
                  v-if="!['G10', 'G12', 'D1', 'D2', 'D3', 'B4', 'PG'].includes(adForm.highest_education)">
                  </div>
                </v-col>

                <v-col :span="8">
                  <v-card title="Grade 12 / Diploma" :bordered="false">
                    <v-form direction="vertical" :model="adForm" :rules="g12AdRules" ref="g12AdformRef">
                      <v-form-item label="Start Date" prop="g12_start_date">
                        <datepicker placeholder="Start Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g12_start_date" @change="(val) => selectChange('adForm', 'g12_start_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Completion Date" prop="g12_completion_date">
                        <datepicker placeholder="Completion Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g12_completion_date" @change="(val) => selectChange('adForm', 'g12_completion_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Institution Name" prop="g12_institution_name">
                        <v-input size="large" v-model="adForm.g12_institution_name" placeholder="Institution Name"
                          autocomplete="nope"></v-input>
                      </v-form-item>
                      <v-form-item label="Location" prop="g12_location">
                        <v-select search placeholder="Location" size="large"
                          v-model="adForm.g12_location" :data="countriesOptions" :filter="filterDropDown"
                          @change="(val) => selectChange('adForm', 'g12_location', val)"
                          notFoundContent="No match found"></v-select>
                      </v-form-item>
                    </v-form>
                  </v-card>
                  <div style="width:calc(100% - 16px);height:100%;background-color:rgba(0, 0, 0, .15);position:absolute;top:0;left:8px;padding: 16px;margin:auto;"
                  v-if="!['G12', 'D1', 'D2', 'D3', 'B4', 'PG'].includes(adForm.highest_education)">
                  </div>
                </v-col>

                <v-col :span="8">
                  <v-card title="Bachelors / Masters" :bordered="false">
                    <v-form direction="vertical" :model="adForm" :rules="gAdRules" ref="gAdformRef">
                      <v-form-item label="Start Date" prop="g_start_date">
                        <datepicker placeholder="Start Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g_start_date" @change="(val) => selectChange('adForm', 'g_start_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Completion Date" prop="g_completion_date">
                        <datepicker placeholder="Completion Date" format="MMM, yyyy" :minimumView="'month'" :maximumView="'month'"
                          v-model="adForm.g_completion_date" @change="(val) => selectChange('adForm', 'g_completion_date', val)"></datepicker>
                      </v-form-item>
                      <v-form-item label="Institution Name" prop="g_institution_name">
                        <v-input size="large" v-model="adForm.g_institution_name" placeholder="Institution Name"
                          autocomplete="nope"></v-input>
                      </v-form-item>
                      <v-form-item label="Location" prop="g_location">
                        <v-select search placeholder="Location" size="large"
                          v-model="adForm.g_location" :data="countriesOptions" :filter="filterDropDown"
                          @change="(val) => selectChange('adForm', 'g_location', val)"
                          notFoundContent="No match found"></v-select>
                      </v-form-item>
                    </v-form>
                  </v-card>
                  <div style="width:calc(100% - 16px);height:100%;background-color:rgba(0, 0, 0, .15);position:absolute;top:0;left:8px;padding: 16px;margin:auto;"
                  v-if="!['B4', 'PG'].includes(adForm.highest_education)">
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-form-item style="margin-top: 20px;display:flex;justify-content:center;">
              <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('adformRef')">Submit</v-button>
              <v-button type="ghost" @click.prevent="resetForm('adformRef')">Reset</v-button>
            </v-form-item>
          </v-form>
        </v-tab-pane>

        <v-tab-pane tab-key="englishLanguageAbility" tab="English Language Ability">
          <v-form direction="horizontal" :model="elForm" :rules="elRules" ref="elformRef">
            <v-form-item label="Test taken"
              prop="test">
              <v-select placeholder="Test taken" size="large" v-model="elForm.test"
                :data="testTypes" @change="eduLevelChange"></v-select>
            </v-form-item>
            <v-form-item label="Overall Score"
              prop="overall_score">
              <v-input size="large" v-model="elForm.overall_score" placeholder="Overall Score"
                autocomplete="nope"></v-input>
            </v-form-item>
            <v-form-item label="Listening Score"
              prop="listening_score">
              <v-input size="large" v-model="elForm.listening_score" placeholder="Listening Score"
                autocomplete="nope"></v-input>
            </v-form-item>
            <v-form-item label="Speaking Score"
              prop="speaking_score">
              <v-input size="large" v-model="elForm.speaking_score" placeholder="Speaking Score"
                autocomplete="nope"></v-input>
            </v-form-item>
            <v-form-item label="Reading Score"
              prop="reading_score">
              <v-input size="large" v-model="elForm.reading_score" placeholder="Reading Score"
                autocomplete="nope"></v-input>
            </v-form-item>
            <v-form-item label="Writing Score"
              prop="writing_score">
              <v-input size="large" v-model="elForm.writing_score" placeholder="Writing Score"
                autocomplete="nope"></v-input>
            </v-form-item>
            <v-form-item :wrapper-col="{offset:6, span: 14 }">
              <v-button type="primary" style="margin-right:10px" @click.prevent="submitForm('elformRef')">Submit</v-button>
              <v-button type="ghost" @click.prevent="resetForm('elformRef')">Reset</v-button>
            </v-form-item>
          </v-form>
        </v-tab-pane>

        <v-tab-pane tab-key="uploadDocuments" tab="Upload Documents">
          <div class="document-sec" v-if="student && student.documents_uploaded && student.documents_uploaded.length">
            <h4>Uploaded documents</h4>
            <div v-for="(doc, index) in student.documents_uploaded" :key="index">
              <v-popconfirm title="Want to delete ?" ok-text="Yes" cancel-text="No" placement="right"
                @confirm="() => delteDocument(doc)">
                <a href="javascript:;">
                  <i class="anticon anticon-delete" style="cursor:pointer"></i>
                </a>
              </v-popconfirm>
              <i class="anticon anticon-paper-clip"></i>
              <a :href="doc.url" target="_blank">{{doc.name}}</a>
            </div>
          </div>
          <div class="document-sec no-docs" v-if="student && !student.documents_uploaded">
            No documents uploaded
          </div>

          <v-upload :name="'file'" drag multiple @change="onDocSelected">
            <p class="ant-upload-drag-icon">
              <v-icon type="inbox"></v-icon>
            </p>
            <p class="ant-upload-text">Upload Documents</p>
            <p class="ant-upload-hint">
              <div>Click or Drag documents to this area to upload</div>
              <div>Acceptable file types include: pdf, jpg, png</div>
            </p>
          </v-upload>

        </v-tab-pane>

      </v-tabs>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Datepicker from 'vuejs-datepicker'
import countriesDetail from '../../assets/countries.json'
import { validateString, validateSpaceString, validateNumber, validateSpaceStringNumeric,
  validateEmail, validatePhoneNumber, validateDate, validateAddress } from '../validations'

export default {
  name: 'AssociateAddStudent',
  computed: {
    ...mapGetters([
      'lov',
      'user',
      'schoolPrograms',
      'student'
    ])
  },
  data () {
    return {
      showAddDetails: false,
      activeTab: null,
      selectedProgram: null,
      countriesOptions: countriesDetail.map(x => ({label: x.name, value: x.name})),
      pdForm: {
        first_name: null,
        last_name: null,
        gender: null,
        country_of_birth: null,
        dob: null,
        personal_email: null,
        phone_number: null,
        street_address: null,
        country: null,
        city: null,
        province: null,
        zip_code: null
      },
      elForm: {
        test: null,
        overall_score: null,
        listening_score: null,
        speaking_score: null,
        reading_score: null,
        writing_score: null
      },
      adForm: {
        highest_education: null
      },
      cmForm: {
        comments: null
      },
      pdRules: {
        first_name: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateSpaceString
        }],
        last_name: [{
          validator: validateSpaceString
        }],
        gender: [{
          required: true,
          message: '* Required'
        }],
        country_of_birth: [{
          required: true,
          message: '* Required'
        }],
        dob: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateDate
        }],
        personal_email: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateEmail
        }],
        phone_number: [{
          required: true,
          message: '* Required'
        }, {
          validator: validatePhoneNumber
        }],
        street_address: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateAddress
        }],
        country: [{
          required: true,
          message: '* Required'
        }],
        city: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateString
        }],
        province: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateString
        }],
        zip_code: [{
          required: false,
          message: '* Required'
        }, {
          validator: validateSpaceStringNumeric
        }]
      },
      elRules: {
        test: [{
          required: true,
          message: '* Required'
        }],
        overall_score: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        listening_score: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        speaking_score: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        reading_score: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }],
        writing_score: [{
          required: true,
          message: '* Required'
        }, {
          validator: validateNumber
        }]
      },
      adRules: {
        highest_education: [{
          required: true,
          message: '* Required'
        }]
      },
      g10AdRules: {},
      g12AdRules: {},
      gAdRules: {},
      cmRules: {
        comments: [{
          required: true,
          message: '* Required'
        }]
      },
      optionsStudyLevels: [{
        label: 'Grade-10',
        value: 'G10'
      }, {
        label: 'Grade-12',
        value: 'G12'
      }, {
        label: '1-Year Post-Secondary Certificate',
        value: 'D1'
      }, {
        label: '2-Year Undergraduate Diploma',
        value: 'D2'
      }, {
        label: '3-Year Undergraduate Advanced Diploma',
        value: 'D3'
      }, {
        label: '4-Year Bachelor\'s Degree',
        value: 'B4'
      }, {
        label: 'Postgraduate Certificate / Master\'s Degree',
        value: 'PG'
      }],
      testTypes: [{
        label: 'IELTS',
        value: 'IELTS'
      }, {
        label: 'TOEFL',
        value: 'TOEFL'
      }, {
        label: 'PTE',
        value: 'PTE'
      }],
      optionsProvince: [],
      optionsCollege: [],
      optionsPrograms: [],
      collegesList: [],
      programsList: []
    }
  },
  watch: {
    schoolPrograms: {
      handler (val) {
        this.optionsPrograms = val.map(program => {
          return {
            label: program.name,
            value: program.name
          }
        })
        this.programsList = [...val]
      }
    },
    lov: {
      handler (val) {
        if (!val) {
          this.$store.dispatch('getLov')
        } else {
          for (let key in val.study_levels) {
            this.optionsStudyLevels.push({value: key, label: val.study_levels[key]})
          }
          for (let key in val.provinces) {
            this.optionsProvince.push({
              label: key,
              value: key
            })
            val.provinces[key].map(college => {
              this.optionsCollege.push({
                label: college,
                value: college
              })
            })
          }
          this.collegesList = [...this.optionsCollege]
        }
      },
      immediate: true
    },
    student: {
      handler (val) {
        if (val) {
          if (val.personal_details && val.academic_details && val.english_language_ability) {
            this.activeTab = 'uploadDocuments'
            this.pdForm = val.personal_details
            this.adForm = val.academic_details
            this.elForm = val.english_language_ability
          } else if (val.personal_details && val.academic_details) {
            this.activeTab = 'englishLanguageAbility'
            this.pdForm = val.personal_details
            this.adForm = val.academic_details
          } else if (val.personal_details) {
            this.activeTab = 'academicDetails'
            this.pdForm = val.personal_details
          } else if (!val.personal_details) {
            this.activeTab = 'personalDetails'
          } else {
            this.activeTab = 'uploadDocuments'
          }
        }
      }
    }
  },
  methods: {
    userAction (data) {
      if (data.content === 'Logout') {
        fb.logout()
        this.$router.push('/auth')
      }
    },
    submitForm (formName) {
      if (formName === 'adformRef') {
        const highestEducation = this.adForm.highest_education
        if (highestEducation) {
          if (highestEducation === 'G10') {
            Object.keys(this.adForm).forEach(x => {
              if (!x.startsWith('g10') && x!=='highest_education') {
                delete(this.adForm[x])
              }
            })
            this.$refs['g10AdformRef'].validate((valid) => {
              if (valid) {
                this.$store.dispatch('updateStudent', {id: this.student.id, payload: {academic_details: this.adForm}, associate: this.user.ref})
              } else {
                return false
              }
            })
          } else if (['G10', 'G12', 'D1', 'D2', 'D3'].includes(highestEducation)) {
            let isValid = true
            const formList = ['g10AdformRef', 'g12AdformRef']
            Object.keys(this.adForm).forEach(x => {
              if (!x.startsWith('g1') && x!=='highest_education') {
                delete(this.adForm[x])
              }
            })

            formList.forEach(x => {
              this.$refs[x].validate((valid) => {
                if (valid) {
                  isValid = true
                } else {
                  isValid = false
                  return false
                }
              })
            })

            if (isValid) {
              this.$store.dispatch('updateStudent', {id: this.student.id, payload: {academic_details: this.adForm}, associate: this.user.ref})
            } else {
              return false
            }
          } else if (['G10', 'G12', 'D1', 'D2', 'D3', 'B4', 'PG'].includes(highestEducation)) {
            let isValid = true
            const formList = ['g10AdformRef', 'g12AdformRef', 'gAdformRef']

            formList.forEach(x => {
              this.$refs[x].validate((valid) => {
                if (valid) {
                  isValid = true
                } else {
                  isValid = false
                  return false
                }
              })
            })
            if (isValid) {
              this.$store.dispatch('updateStudent', {id: this.student.id, payload: {academic_details: this.adForm}, associate: this.user.ref})
            } else {
              return false
            }
          }
        } else {
          return false
        }
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (formName === 'pdformRef') {
              this.$store.dispatch('addStudent', {associate: this.user.ref, personal_details: this.pdForm})
            } else if (formName === 'elformRef') {
              this.$store.dispatch('updateStudent', {id: this.student.id, payload: {english_language_ability: this.elForm}, associate: this.user.ref})
            } else if (formName === 'cmformRef') {
              this.$store.dispatch('addNotification', {to: 'CanEd', from: this.user.ref, text: this.cmForm.comments})
              this.resetForm('cmformRef')
            }
          } else {
            return false
          }
        })
      }
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    eduLevelChange (val) {
      if (val) {
        const g10RulesList = ['g10_start_date', 'g10_completion_date', 'g10_institution_name', 'g10_location'],
          g12RulesList = ['g12_start_date', 'g12_completion_date', 'g12_institution_name', 'g12_location'],
          gRulesList = ['g_start_date', 'g_completion_date', 'g_institution_name', 'g_location']

        if (val === 'G10') {
          g10RulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.g10AdRules[x] = rules
            })
          g12RulesList
            .forEach(x => this.g12AdRules[x] = null)
          gRulesList
            .forEach(x => this.gAdRules[x] = null)

          this.$refs['g12AdformRef'].resetFields()
          this.$refs['gAdformRef'].resetFields()
        } else if (['G10', 'G12', 'D1', 'D2', 'D3'].includes(val)) {
          g10RulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.g10AdRules[x] = rules
            })
          g12RulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.g12AdRules[x] = rules
            })
          gRulesList
            .forEach(x => this.gAdRules[x] = null)

          this.$refs['gAdformRef'].resetFields()
        } else if (['G10', 'G12', 'D1', 'D2', 'D3', 'B4', 'PG'].includes(val)) {
          g10RulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.g10AdRules[x] = rules
            })
          g12RulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.g12AdRules[x] = rules
            })
          gRulesList
            .forEach(x => {
              let rules = []
              if (x.includes('date')) {
                rules.push({validator: validateDate})
              }
              this.gAdRules[x] = rules
            })
        }
      }
    },
    eduDetailsAdd (ev) {
      this.showAddDetails = true
    },
    closeDetailsAdd () {
      this.showAddDetails = false
    },
    submitDetailsAdd () {
      this.showAddDetails = false
    },
    onDocSelected (info) {
      if (!info.error && info.file.status !== 'uploading') {
        const files = info.fileList
        const mimetypes = ["image/jpeg", "image/png", "application/pdf"]
        files.map(file => {
          if (mimetypes.includes(file.type)) {
            this.$store.dispatch('addStudentDocument', {document: file, id: this.student.id, associate: this.user.ref})
          } else {
            this.$store.dispatch('setErrorMessage', 'File type not supported')
          }
        })
      }
      if (info.file.status === 'done') {
        console.log(info.file.name + '     Done.')
      }
    },
    delteDocument (document) {
      this.$store.dispatch('deleteStudentDocument', {id: this.student.id, document: document})
    },
    selectChange (form, key, val) {
      this[form][key] = val
      if (key === 'country') {
        this[form]['phone_number'] = countriesDetail.find(x => x.name === val).dial_code
      }
    },
    selectDate (form, key, val) {
      this[form][key] = val
    },
    selectProvince (val) {
      if (val) {
        const colleges = [...this.lov.provinces[val]]
        this.optionsCollege = colleges.map(college => {
          return {
            label: college,
            value: college
          }
        })
      } else {
        this.optionsCollege = [...this.collegesList]
      }
    },
    selectCollege (val) {
      if (val) {
        this.$store.dispatch('getSchoolProgramsBySchoolName', val)
      } else {
        this.optionsPrograms = []
      }
    },
    applyProgram (val) {
      if (this.user.personal_details && this.user.academic_details &&
        this.user.english_language_ability && this.user.documents_uploaded) {
        const selectedProgram = this.programsList.find(program => program.name === this.selectedProgram)
        selectedProgram.status = 'Applied'
        selectedProgram.userRef = this.user.ref
        selectedProgram.prog_id = selectedProgram.id
        selectedProgram.prog_ref = selectedProgram.ref
        selectedProgram.visa_status = null
        selectedProgram.source = 'WebApp'
        this.$store.dispatch('addApplication', selectedProgram)
      } else {
        if (val.personal_details && val.academic_details && val.english_language_ability) {
          this.activeTab = 'uploadDocuments'
        } else if (val.personal_details && val.academic_details) {
          this.activeTab = 'englishLanguageAbility'
        } else if (val.personal_details) {
          this.activeTab = 'academicDetails'
        } else if (!val.personal_details) {
          this.activeTab = 'personalDetails'
        } else {
          this.activeTab = 'uploadDocuments'
        }
      }
    },
    showApplyProgram () {
      this.activeTab = 'applyProgram'
    },
    filterDropDown (val, item) {
      const selected = val.toLowerCase()
      return item.label.toLowerCase().indexOf(selected) > -1
    }
  },
  components: {
    Datepicker
  }
}
</script>

<style scoped>
.upload-action {
  margin-bottom: 10px;
  margin-top: 10px;
}
.select-wrap {
  padding-left: 40px;
}
.select-options-wrap {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 8px;
  width: 450px;
}
.select-options-wrap label {
  width: 250px;
  font-weight: 600;
}
.apply-program .header {
  font-weight: 700;
  margin: 20px 0 30px;
  display: inline-block;
  font-size: 14px;
}
.apply-program .header > span {
  margin-right: 20px;
}
.breadcrumb {
  padding: 16px;
}
.academic-details .ant-form-item {
  margin-bottom: 10px;
}
.academic-details-header {
  font-weight: 600;
  margin-bottom: 14px;
}
.apply-program-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.apply-program-wrap .search {
  width: 45%;
  display: flex;
  justify-content: center;
  padding-top: 50px;
}
.apply-program-wrap .search button {
  font-size: 28px;
  padding: 12px 18px;
  height: auto;
}
.apply-program-wrap .comments {
  width: 45%;
  padding-top: 50px;
}
</style>

<style>
.ant-upload.ant-upload-drag {
  padding-bottom: 0px;
  height:200px !important;
}
.ant-breadcrumb-link a, .ant-breadcrumb-link i {
  color: #108ee9;
  text-decoration: none;
}
.document-sec {
  height:calc(100vh - 470px) !important;
  overflow-y: auto;
  margin-bottom: 5px;
  position: relative;
}
.document-sec.no-docs {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ff3366;
}
.ant-upload.ant-upload-drag .ant-upload-drag-container {
  display: flex;
  vertical-align: middle;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  height: 100%;
}
.ant-upload.ant-upload-drag:not(.ant-upload-disabled):hover {
  border-color: #ff3366;
}
.vdp-datepicker input {
    position: relative;
    display: inline-block;
    padding: 4px 7px;
    width: 100%;
    height: 28px;
    font-size: 12px;
    line-height: 1.5;
    color: rgba(0,0,0,.65);
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    -webkit-transition: all .3s;
    transition: all .3s;
}
</style>



// WEBPACK FOOTER //
// src/views/Associate/AssociateAddStudent.vue